import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useScrollStore = defineStore('scroll', () => {

	const header = ref(null);
	const headerFixed = ref(false);

	const headerHeight =  computed(() => header.value.offsetHeight);

	const handleScroll = () => {
		headerFixed.value =  window.scrollY > headerHeight.value;
	}

	const scrollToId = (id) => {
		const el = document.getElementById(id);
		if (el) {
			const elementPosition = el.getBoundingClientRect().top;
			const offsetPosition = elementPosition - headerHeight.value;
			setTimeout(() => {
				window.scrollBy({
					top: offsetPosition,
					behavior: "smooth",
				});				
			}, 100)
		}
	}

    return {
		handleScroll,
		scrollToId,
		
		header,
		headerHeight,
		headerFixed,
	}
})
